// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2Cdn1","containerItemsCenter":"Skeleton_containerItemsCenter__1mfox"};